module.exports = {
      id: "right-arrow-two-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#right-arrow-two",
      toString: function () {
        return this.url;
      }
    }